import { useEffect } from "react"
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom"
import { initVars } from "./models/DefaultValues"
import { ExClient } from "./models/ExClient"
import { AboutPage } from "./pages/AboutPage"
import { AffiliatePage } from "./pages/AffiliatePage"
import { RegisterPage } from "./pages/auth/register"
import { AvailablePage } from "./pages/AvailablePage"
// import {TariffsPage} from "./pages/TariffsPage";
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.min.css"
import { AvoidScamsPage } from "./pages/AvoidScamsPage"
import { CardsPage } from "./pages/CardsPage"
import { ContactPage } from "./pages/ContactPage"
import { ExchangePage } from "./pages/ExchangePage"
import IBANPage from "./pages/home/iban"
import { IndexPage } from "./pages/IndexPage"
import { InfoPage } from "./pages/InfoPage"
import { LoginPage } from "./pages/LoginPage"
import { Logout } from "./pages/Logout"
import { NotFoundPage } from "./pages/NotFoundPage"
import { PasswordRecoveryPage } from "./pages/PasswordRecoveryPage"
import { PasswordSetPage } from "./pages/PasswordSetPage"
import { RatesPage } from "./pages/RatesPage"

const App = () => {
  useEffect(() => {
    initVars(process.env.NODE_ENV !== "production" || process.env["REACT_APP_BUILD_TYPE"] === "dev")
    ExClient.init()
  }, [])
  return (
    <>
      <ToastContainer autoClose={4000} position="top-right" />
      <BrowserRouter>
        <Switch>
          <Route exact={true} path="/" component={IndexPage} />
          <Route path="/login" component={LoginPage} />
          <Route exact path="/register/:register_type?" component={RegisterPage} />
          <Route path="/exchange" component={ExchangePage} />
          <Route path="/transfer" component={ExchangePage} />
          <Route path="/logout" component={Logout} />
          <Route path="/rates" component={RatesPage} />
          <Route path="/cards" component={CardsPage} />
          <Route path="/affiliate" component={AffiliatePage} />
          <Route path="/about" component={AboutPage} />
          <Route path="/contact_us" component={ContactPage} />
          <Route path="/available" component={AvailablePage} />
          <Route path="/recovery" component={PasswordRecoveryPage} />
          <Route path="/new_password" component={PasswordSetPage} />
          <Route exact path="/404" component={NotFoundPage} />
          <Route path="/info" component={InfoPage} />
          <Route path="/iban" component={IBANPage} />
          {/* <Route path="/tariffs" component={TariffsPage} /> */}
          <Route path="/avoid-fraud" component={AvoidScamsPage} />
          <Redirect path="/license" to="/" />
          <Route exact={true} path="/client/index" component={ExchangePage} />
          <Redirect to="/404" />
        </Switch>
      </BrowserRouter>
    </>
  )
}

export default App
